<template>
  <v-row no-gutters ref="mapContainer">
    <v-col class="pa-1" cols="2" style="min-width: 250px" :style="{maxHeight: $parent.$el.offsetHeight - 80 + 'px'}">
      <route-list-header @add="addRoute"
                         :del="!!selectedRoute.idnr"
                         @delete="deleteRoute"></route-list-header>
      <route-list @route-update="updateRoute"
                  @mouseover="highlightRoute"
                  @mouseout="removeHighlight"
                  @selected="updateSelectedRoute"
                  :selected="selectedRoute"></route-list>
    </v-col>
    <v-col class="pa-1">
      <map-component modify
                     @map-created="mapCreated"
                     @go-home="handleGoHome"
                     @map-toolbar-undo="handleUndo"
                     @map-toolbar-clear="handleDeleteAll"
                     :height="$parent.$el.offsetHeight - 120 + 'px'"
      ></map-component>
    </v-col>
  </v-row>
</template>

<script>
import 'gox'
import MapComponent from "@/components/MainContent/Map";
import RouteListHeader from "@/components/MainContent/QuestionCreator2/Routes/RouteListHeader";
import {mapGetters, mapActions, mapMutations} from 'vuex'
import RouteList from "@/components/MainContent/QuestionCreator2/Routes/RouteList";
import {geojsonToFeature, featureToGeojson} from '@/lib/gis-functions'
import {buffer} from 'ol/extent'

export default {
  name: "RoutePlotter",
  components: {RouteList, RouteListHeader, MapComponent},

  computed: {
    ...mapGetters({
      routes: 'getRoutes',
      question: 'getNewQuestion',
      icons: 'getIcons'
    }),
    getHeight() {
      let windowHeight = document.body.offsetHeight;
      let offset = 140;

      return `${windowHeight - offset}px`
    }
  },

  data() {
    return {
      map: null,
      modifyInteraction: null,
      selectedRoute: {},
      routeLayers: {},
      pointsLayer: {},
      startPointStyle: () => {
        let style = new GOX.Style();
        let JSONStyle = style.JSONtoStyle({
          image: {
            src: require('@/assets/icons/' + this.icons.start),
            anchor: [0.5, 48],
            anchorXUnits: 'fraction',
            anchorYUnits: 'pixels'
          }
        });

        return JSONStyle
      },
      endPointStyle: () => {
        let style = new GOX.Style();
        let JSONStyle = style.JSONtoStyle({
          image: {
            src: require('@/assets/icons/' + this.icons.end),
            anchor: [0.5, 48],
            anchorXUnits: 'fraction',
            anchorYUnits: 'pixels'
          }
        });

        return JSONStyle
      }
    }
  },

  methods: {
    ...mapMutations(['CREATOR_ADD_ROUTE', 'CREATOR_REMOVE_ROUTE', 'addQuestionRoutes', 'CREATOR_CLEAR_ROUTES']),
    addRoute() {

      let routeObj = {
        idnr: Math.random(),
        value: '',
        colour: '#FF0000',
        geoJSON: ''
      };

      console.log("Add route", routeObj);
      this.selectedRoute = routeObj;
      console.dir(this.selectedRoute)
      this.CREATOR_ADD_ROUTE(routeObj);
      this.createDrawLayer(routeObj.idnr, true);
      this.updateSelectedRoute(routeObj);
    },
    deleteRoute(routeObj) {
      let routeToDelete = routeObj || this.selectedRoute
      this.$confirm({
        title: 'Delete Route',
        message: 'Are you sure you want to remove this route?'
      }).then(() => {
        this._deleteRouteInternal(routeToDelete);
        this.CREATOR_REMOVE_ROUTE(routeToDelete.idnr);
        this.selectedRoute = {};
      })
    },
    _deleteRouteInternal(routeToDelete) {
      if (routeToDelete) {
        this.map.removeLayer(this.routeLayers[routeToDelete.idnr]);
        this.cancelDrawInteractions();
        delete this.routeLayers[routeToDelete.idnr]
      }
    },
    handleDeleteAll() {
      this.$confirm({
        title: 'Delete All Routes',
        message: 'Are you sure you want to remove ALL routes?'
      }).then(() => {
        this.routes.forEach(r => {
          this._deleteRouteInternal(r);
          this.CREATOR_CLEAR_ROUTES();
        })
      })
    },
    handleUndo() {
      this.routeLayers[this.selectedRoute.idnr].removeLastDrawnPoint();
    },
    handleGoHome() {
      var src = this.pointsLayer.getSource();
      if (src.getFeatures().length > 1) {
        this.map.setExtent(buffer(this.pointsLayer.getSource().getExtent(), 100));
      } else {
        this.map.setExtent(this.pointsLayer.getSource().getExtent(), 15);
      }
    },
    highlightRoute(route) {
      let currentStyle = this.routeLayers[route.idnr].getStyle();
      console.dir(currentStyle)
      currentStyle[0].stroke_.width_ = 10;
      this.routeLayers[route.idnr].setStyle(currentStyle)
    },
    removeHighlight(route) {
      this.setLayerStyle(this.routeLayers[route.idnr])
    },
    updateRoute(route) {
      console.log("UPDATE", route)
      let routeToMerge = {}
      if (route.feature) {
        routeToMerge.geoJSON = featureToGeojson(route.feature);
      }

      if (route.colour) {
        routeToMerge.colour = route.colour
      }

      if (route.value) {
        routeToMerge.value = route.value
      }

      console.dir({...this.selectedRoute, ...routeToMerge})

      this.addQuestionRoutes({...this.selectedRoute, ...routeToMerge});
      this.updateLayerStyles();

    },
    loadExistingRoutes() {
      this.routes.forEach(r => {
        var features = geojsonToFeature(r.geoJSON)
        this.createDrawLayer(r.idnr);
        this.routeLayers[r.idnr].getSource().addFeatures(features)
      })
    },
    updateSelectedRoute(route) {
      console.log('UPDATE ROUTE', route)
      this.selectedRoute = route;
      this.updateLayerStyles();
      this.cancelDrawInteractions();
      this.enableDrawingInteractions();
    },
    createPointLayer() {
      //Start and End points
      this.pointsLayer = new GOX.Layer.Vector({
        id: 'points',
        geometry: 'Point'
      });
      this.map.addLayer(this.pointsLayer);

      let startPoint = this.question.startpoint;
      let endPoint = this.question.endpoint;

      let sFeatures = new geojsonToFeature(startPoint, {
        dataProjection: 'EPSG:27700',
        featureProjection: 'EPSG:27700'
      });

      sFeatures.forEach((feature) => {
        feature.setStyle(this.startPointStyle);
      });

      let eFeatures = new geojsonToFeature(endPoint, {
        dataProjection: 'EPSG:27700',
        featureProjection: 'EPSG:27700'
      });

      eFeatures.forEach((feature) => {
        feature.setStyle(this.endPointStyle);
      });

      this.pointsLayer.getSource().addFeatures(sFeatures);
      this.pointsLayer.getSource().addFeatures(eFeatures);

      this.handleGoHome();
    },
    createDrawLayer(id, startDraw) {
      this.routeLayers[id] = new GOX.Layer.Vector({
        id: `${id}`,
        geometry: 'LineString'
      });

      this.map.addLayer(this.routeLayers[id]);

      this.routeLayers[id].on('draw-end', (e) => {
        this.routeLayers[id].stopDrawing();
      });

      this.routeLayers[id].on('draw-stop', (e) => {
        console.log('draw stop');
        console.dir(e)
        this.updateRoute({feature: e.feature});
      });

      this.routeLayers[id].on('modify-end', (e) => {
        console.log("MEND", e)
      });

      this.setLayerStyle(this.routeLayers[id]);

      if (startDraw) {
        this.routeLayers[id].startDrawing();
      }
    },
    setLayerStyle(layer) {
      if (!layer) {
        return
      }
      let styleArray = [];
      let style = new GOX.Style();
      let routeObject = this.routes.find(r => r.idnr.toString() === layer.id.toString());

      if (!routeObject) {
        return
      }

      console.dir(routeObject)
      let styleObject = {
        stroke: {
          width: 5,
          color: routeObject.colour
        }
      };
      styleArray.push(style.JSONtoStyle(styleObject));
      if (this.selectedRoute.idnr && this.selectedRoute.idnr.toString() === layer.id.toString()) {
        var outline = new GOX.Style();
        var outlineStyle = {
          stroke: {
            width: 9,
            color: 'white'
          }
        };
        styleArray.splice(0, 0, outline.JSONtoStyle(outlineStyle));
      }
      layer.setStyle(styleArray)
    },
    updateLayerStyles() {
      for (let i in this.routeLayers) {
        this.setLayerStyle(this.routeLayers[i])
      }
    },
    cancelDrawInteractions() {
      if (!this.selectedRoute.idnr) {
        return
      }
      for (let i in this.routeLayers) {
        if (this.selectedRoute.idnr.toString() === i.toString()) {
          this.routeLayers[i].stopDrawing();
        }
        if (this.modifyInteraction) {
          this.modifyInteraction.stop();
          this.modifyInteraction = null;
        }
      }
    },
    enableDrawingInteractions() {
      if (this.selectedRoute.geoJSON) {
        console.log("existing route, modify")
        this.modifyInteraction = new GOX.Modify({
          layer: this.routeLayers[this.selectedRoute.idnr]
        });

        console.log(this.modifyInteraction)

        this.modifyInteraction.on('modifyend', (e) => {
          this.updateRoute({feature: e.features.item(0)})
        });

        this.modifyInteraction.start(this.map);
      } else {
        console.log("No route, start drawing")
        this.routeLayers[this.selectedRoute.idnr].startDrawing();
      }
    },
    mapCreated(map) {
      console.log("MapPlotRoutesNew -- mapCreated: ");
      this.map = map;

      this.createPointLayer();
      this.loadExistingRoutes();

    },
  }
}
</script>

<style scoped>

</style>
